<template>
  <v-container fluid id="login" class="auth-shell" :class="{ 'auth-shell--mobile-app': isMobileApp }">
    <v-layout :align-center="isMobileApp || $vuetify.breakpoint.smAndUp" :justify-center="isMobileApp || $vuetify.breakpoint.smAndUp" column class="auth-content">
      <div class="auth-brand display-1 mb-2 font-weight-regular">
        <v-layout row wrap>
          <v-flex shrink>
            <v-img v-if="brandConfig && brandConfig.logos" contain class="mb-2" :src="brandConfig.logos.inline" height="60" :alt="`${currentBrand} logo`" />
          </v-flex>
        </v-layout>
      </div>
      <div class="auth-portal-label">
        <span class="body-2">Admin Portal</span>
      </div>
      <router-view class="mt-4" />
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import { isNativeMobileApp } from "@/mobile/runtime";
export default {
  name: "authentication",
  data() {
    return {
      isStoreSync: false,
    };
  },
  created() {
    this.detectBrand();
  },
  computed: {
    ...mapGetters("brand", ["currentBrand", "brandConfig"]),
    isMobileApp() {
      return isNativeMobileApp;
    },
  },
  methods: {
    detectBrand() {
      const host = window.location.hostname.toLowerCase();
      // ✅ Adjust domains as needed
      if (host.includes("storesyncpos")) {
        this.isStoreSync = true;
      } else if (host.includes("autorepairdesk")) {
        this.isStoreSync = false;
      } else {
        // fallback to StoreSyncPOS by default
        this.isStoreSync = true;
      }
    },
  },
};
</script>
<style scoped>
#login {
  background: var(--brand-bg, var(--v-background-base, #ebedf1));
  color: var(--brand-text, inherit);
}
.auth-shell { min-height: 100vh; overflow-y: auto; padding: 32px 16px; }
.auth-content { min-height: calc(100vh - 64px); }
.auth-shell--mobile-app {
  height: 100vh;
  height: 100dvh;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: max(24px, env(safe-area-inset-top)) 20px max(24px, env(safe-area-inset-bottom));
}
.auth-shell--mobile-app .auth-content { min-height: 100%; }
.auth-shell--mobile-app .auth-brand { margin-bottom: 0 !important; width: min(100%, 420px); }
.auth-shell--mobile-app .auth-portal-label {
  color: var(--brand-text, currentColor);
  margin-bottom: 8px;
  opacity: 0.72;
  text-align: center;
  width: min(100%, 420px);
}
.theme--dark #login {
  background: var(--v-background-base, #121212);
  color: var(--v-theme-base, #ffffff);
}
@media (max-width: 599px), (max-height: 680px) {
  .auth-shell { padding-top: 20px; padding-bottom: 20px; }
  .auth-content { min-height: 0; }
}
@media (max-height: 680px) {
  .auth-shell--mobile-app { padding-top: max(12px, env(safe-area-inset-top)); padding-bottom: max(12px, env(safe-area-inset-bottom)); }
  .auth-shell--mobile-app .auth-content { justify-content: flex-start !important; }
  .auth-shell--mobile-app .auth-brand { max-width: 280px; }
}
</style>
